(function ($) {
    var $body = $('body');

    $('.navbar-collapse').on('show.bs.collapse hide.bs.collapse', function (e) {
        if (e.type === 'hide') {
            $body.removeClass('menu-open');
        } else {
            $body.addClass('menu-open');
        }
    });
})( jQuery );
